import flow from 'lodash/flow';
import noop from 'lodash/noop';
import memoizeOne from 'memoize-one';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { AnalyticsSubject } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { FavoriteCellView } from '@atlassian/jira-common-directory-v2/src/components/favourite-cell-v2/view.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { EntityCellProps } from '../../../../model/index.tsx';
import {
	getName,
	isFavorite,
	isPending,
	getChangeFavorite,
} from '../../../../state/selectors/filters/index.tsx';
import type { State } from '../../../../state/types.tsx';

const mapStateToPropsFactory = () => {
	const onClickFactory = memoizeOne(
		(state: State, id: string) => (analyticsEvent: UIAnalyticsEvent) => {
			const changeFavorite = getChangeFavorite(state);
			return changeFavorite
				? changeFavorite(
						{
							id,
							type: 'filters',
							value: !isFavorite(state, id),
						},
						analyticsEvent,
					)
				: noop;
		},
	);
	return (state: State, ownProps: EntityCellProps) => ({
		isFavorite: isFavorite(state, ownProps.id),
		favoriteItemName: getName(state, ownProps.id),
		id: ownProps.id,
		onClick: onClickFactory(state, ownProps.id),
		pending: isPending(state, ownProps.id),
		isShownInList: true,
	});
};

export default flow(
	AnalyticsSubject('filter'),
	// @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
	connect(mapStateToPropsFactory, {}),
)(FavoriteCellView);
